import React, { useState } from "react";
import { toast } from "react-toastify";

// components
import Input from "./Input/Input";
import Button from "./Button/Button";
import Header from "./Header/Header";

// utils
import { forgotPassword } from "src/utils/requests/register_screen/forgot";

// animation
import FadeTop from "src/components/Animation/FadeTop";

const ForgotForm = ({ changeForm }) => {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    // set email validation
    if (email !== "") {
      setLoading(true);
      await forgotPassword(email)
        .then((res) => {
          if (res.data.Status) {
            toast.success(res.data.Results);
            setEmail("");
          } else {
            toast.error(res.data.ErrorMessage);
          }

          setLoading(false);
        })
        .catch((err) => {
          toast.error(err);
          setLoading(false);
        });
    } else {
      toast.info("Please enter your email");
    }
  };

  return (
    <form>
      <FadeTop duration={0.3}>
        <Header
          title="Forgot Your Password?"
          text="No worries, you just need to type your email address or username and we will send the verification code."
          icon
          handleChange={() => changeForm(1)}
        />
        <div className="sm-space-20"></div>
        <Input
          label="Email"
          placeholder="Email Address"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <div className="sm-space-200"></div>
        <Button
          label={!loading ? "RESET MY PASSWORD" : "loading..."}
          fill
          handleClick={handleSubmit}
        />
      </FadeTop>
    </form>
  );
};

export default ForgotForm;
